module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/HELLRAISER_STYLE.6aa682ce.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/HELLRAISER_STYLE.png
// module id = 1162
// module chunks = 16